import * as React from "react";
import Select from "react-select";
import { TemperatureUnitContext } from "../../context/app-context";
import { selectTheme, styles } from "../../services/selectTheme";

export const TemperatureUnitPicker = () => {
    const [unit, setUnit] = React.useContext(TemperatureUnitContext);

    const options = [
        { value: "C", label: "°C" },
        { value: "F", label: "°F" }
    ];
    return (
        <Select
            theme={selectTheme}
            options={options}
            styles={styles}
            isSearchable={false}
            onChange={(option) => {
                setUnit(option.value);
            }}
            value={options.filter((o) => o.value === unit)}
            placeholder=""
        />
    );
};
